// „Коригирай общото" в листа „Доставка" (фактура и стокова): въведеното в реда
// „Общо" (нето или бруто) → разликата в реда с най-голяма сума
// (`deliveryTotalAdjust`). Стотинките закръгляне минават направо с кратко
// съобщение; разлика над 1.00 вече не е закръгляне — пита се, преди да се
// сложи в реда; невъзможната (редът би станал ≤ 0) се отказва с причината.
import { App } from "antd";
import { useTranslation } from "react-i18next";
import { useConfirm } from "../../components/confirm/useConfirm";
import {
  TOTAL_ADJUST_CONFIRM_ABOVE,
  formatSignedDelta,
  type TotalAdjustPlan,
  type TotalColumn,
} from "./deliveryTotalAdjust";

type Params = {
  plan: (column: TotalColumn, target: number, current: number) => TotalAdjustPlan;
  apply: (column: TotalColumn, plan: Extract<TotalAdjustPlan, { kind: "apply" }>) => void;
  nameOf: (productId: number) => string;
};

export const useDeliveryTotalAdjust = ({ plan, apply, nameOf }: Params) => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const confirm = useConfirm();

  return (column: TotalColumn, target: number, current: number) => {
    const result = plan(column, target, current);
    if (result.kind === "none") return;
    if (result.kind === "noRows") {
      message.warning(t("inventoryPage.tadjNoRows"));
      return;
    }
    const product = nameOf(result.productId);
    const delta = formatSignedDelta(result.delta);
    if (result.kind === "tooLarge") {
      message.error(t("inventoryPage.tadjTooLarge", { delta, product }));
      return;
    }
    if (Math.abs(result.delta) <= TOTAL_ADJUST_CONFIRM_ABOVE) {
      apply(column, result);
      message.info(t("inventoryPage.tadjApplied", { delta, product }));
      return;
    }
    void confirm({
      intent: "warning",
      title: t("inventoryPage.tadjConfirmTitle", { delta }),
      explanation: t("inventoryPage.tadjConfirmText", { delta, product, value: result.value }),
      note: { kind: "undo", text: t("inventoryPage.tadjConfirmUndo") },
      confirmLabel: t("inventoryPage.tadjConfirmOk", { product }),
      action: () => apply(column, result),
    });
  };
};
